import { eventTypeOfMappedEvent } from '@src/common/constant/enum';
import { IEventRule } from '@src/emp-3.0/types/mapped-event';
import { IMappedEvent } from '@src/pages/metric-templates/types';
import { EStringOp } from '@src/emp-3.0/types';

export const getInitSimpleMappedEvent = (
  event_name?: string,
  event_category?: string,
): IMappedEvent => {
  return {
    event_id: null,
    event_name: event_name ? event_name : '',
    event_category: event_category ? event_category : '',
    // description: '',
    rules: [[getEmptyRuleGroupInAPIForm()]],
  };
};
export const getEmptyRuleGroupInAPIForm = (): IEventRule => ({
  key: eventTypeOfMappedEvent.all_event_name,
  op: EStringOp.EQ,
  value: [] as string[],
  mapping_rules: [
    [
      {
        tag_key: {
          op: EStringOp.EQ,
          value: [],
        },
        tag_value: {
          op: EStringOp.EQ,
          value: [],
        },
      },
    ],
  ],
  metadata: [],
});
